var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-select',{attrs:{"label":_vm.label,"disabled":_vm.disabled,"fancy":_vm.fancy,"value":_vm.value,"items":_vm.bankKinds},on:{"input":function($event){return _vm.onInput($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }